import styled from 'styled-components';

import * as Common from '../../Styles';
import * as MUI from '@mui/material';

const Theme = Common.Theme;

export const FlexRow = styled(Common.FlexRow)``;

export const FlexColumn = styled(Common.FlexColumn)``;

export const TitleSection = styled(Common.TitleSection)``;

export const TitleRow = styled(Common.TitleRow)``;

export const Title = styled(Common.Title)`
	display: inline;
`;

export const RootContainer = styled(Common.RootContainer)``;

export const NotFound = styled(Common.NotFound)``;

export const Popover = styled(Common.Popover)``;

export const PopoverItem = styled(Common.PopoverItem)``;

export const PopoverTitle = styled(Common.PopoverTitle)``;

export const PopoverBody = styled(Common.PopoverBody)`
	min-width: 220px;
	max-width: min(320px, calc(100vw - 32px));
	padding: 0 1rem 1rem;
`;

export const BackButton = styled(Common.CircularButton)`
	margin: 0;
`;

export const OrderDetailsContainer = styled(Common.Container)`
	margin: 0rem;
	background-color: #ffffff;
	border: 0.5px solid #eaeaea;
	border-radius: 5px;
`;

export const OrderDetailsHeader = styled(Common.FlexRow)`
	display: flex;
	flex-direction: column;
	position: relative;
	padding: 1rem 2rem 0.75rem;
	font-size: 14px;
	line-height: 14px;
`;

export const OrderHeaderActions = styled.div`
	position: absolute;
	top: 0;
	bottom: 0.5rem;
	right: 2rem;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	align-items: flex-end;
	gap: 0.5rem;
`;

export const OrderId = styled.span`
	margin: 0.75rem 0;
	font-weight: bold;
	font-size: 22px;
	line-height: 22px;
`;

export const OrderDate = styled.span`
	margin: 0.5rem 0;
	color: #777777;
`;

export const OrderStats = styled.span`
	color: ${Theme.orange};
	font-weight: bold;
`;

export const CancelOrderButton = styled(Common.Button).attrs({
	variant: 'contained',
	color: 'error',
})`
	min-width: 8.5rem !important;
	margin: 0 !important;
	color: ${Theme.white} !important;
	background-color: ${Theme.red} !important;
	border: 1px solid ${Theme.red} !important;

	&:hover {
		background-color: rgba(227, 57, 70, 0.85) !important;
		border-color: ${Theme.red} !important;
	}
`;

export const OrderStatusPill = styled.span`
	padding: 0.4rem 1rem;
	border-radius: 999px;
	font-size: 12px;
	font-weight: 700;
	letter-spacing: 0.03em;
	text-transform: uppercase;
	white-space: nowrap;
	margin-right: -0.75rem;
`;

export const PartiallyCancelledPill = styled(OrderStatusPill)`
	background-color: rgba(255, 111, 0, 0.12);
	color: ${Theme.orange};
`;

export const OrderCancelledPill = styled(OrderStatusPill)`
	background-color: ${Theme.lightRed};
	color: ${Theme.red};
`;

export const PartiallyFulfilledPill = styled(OrderStatusPill)`
	background-color: rgba(25, 172, 113, 0.12);
	color: ${Theme.green};
`;

export const OrderReturnedPill = styled(OrderStatusPill)`
	background-color: rgba(163, 24, 36, 0.1);
	color: #a31824;
`;

export const Toast = styled.div`
	position: fixed;
	left: 50%;
	bottom: 1.5rem;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	gap: 0.6rem;
	background: ${Theme.black};
	color: ${Theme.white};
	padding: 0.75rem 1.25rem;
	border-radius: 6px;
	font-size: 14px;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
	z-index: 1400;
`;

export const TableContainer = styled(Common.TableContainer)`
	height: ${({ orderNoteExists = false }) => (orderNoteExists ? 'calc(100vh - 617px)' : 'calc(100vh - 463px)')} !important;
	min-width: 560px !important;
`;

export const Table = styled(Common.Table)``;

export const TableHeader = styled(Common.TableHeader)``;

export const TableHeaderRow = styled(Common.TableHeaderRow)``;

export const TableHeaderColumn = styled(Common.TableHeaderColumn)``;

export const TableBody = styled(Common.TableBody)``;

export const TableRow = styled(Common.TableRow)``;

export const TableColumn = styled(Common.TableColumn)``;

export const ProductImage = styled.img`
	width: 3.5rem;
	height: 3.5rem;
	border-radius: 5px;
	background-color: #fafafa;
	border: 0.5px solid #eaeaea; ;
`;

export const ProductName = styled(Common.FlexRow)`
	padding: 0 0 0 1rem;
`;

export const ProductId = styled(Common.FlexRow)`
	padding: 0.5rem 0 0 1rem;
	font-weight: 500;
	color: #777777;
`;

export const ProductPrice = styled(Common.FlexRow)`
	font-weight: 700;
	color: ${Theme.green};
`;

export const ProductQuantity = styled(Common.FlexRow)``;

export const ProductStatus = styled(Common.FlexRow)`
	color: ${Theme.orange};
	cursor: pointer;
`;

export const ProductStatusColumn = styled(Common.FlexColumn)`
	width: 100%;
	cursor: pointer;
`;

export const ProductStatusShipBy = styled.span`
	margin-top: 0.25rem;
	color: ${Theme.darkGrey};
	font-size: 12px;
	font-weight: 500;
`;

export const ProductStatusComment = styled.span`
	margin-top: 0.25rem;
	color: ${Theme.darkGrey};
	font-size: 12px;
	line-height: 16px;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
`;

export const CancellationReasonPanel = styled.div`
	background-color: ${Theme.container};
	border-radius: 4px;
	padding: 0.6rem 0.85rem 0.75rem;
	margin: 0 0 0.5rem;
`;

export const CancellationReasonHeader = styled(Common.FlexRow)`
	align-items: center;
	flex-wrap: wrap;
	gap: 0.4rem;
	margin-bottom: 0.35rem;
	font-size: 11.5px;
	font-weight: 400;
	letter-spacing: 0.05em;
	text-transform: uppercase;
	color: ${Theme.darkGrey};
`;

export const CancellationReasonMeta = styled.span`
	font-weight: 400;
	text-transform: none;
	letter-spacing: 0;
	color: ${Theme.mediumGrey};
`;

export const CancellationReasonTag = styled.span`
	background: ${Theme.white};
	border: 1px solid ${Theme.lightGrey};
	border-radius: 999px;
	padding: 0.1rem 0.55rem;
	font-size: 10.5px;
	font-weight: 700;
	letter-spacing: 0.03em;
	text-transform: uppercase;
	color: ${Theme.darkGrey};
`;

export const CancellationReasonText = styled.div`
	font-size: 13.5px;
	color: ${Theme.black};
	line-height: 1.4;

	${(props) => (props.expanded
		? ''
		: `
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
		`)}
`;

export const ShowMoreButton = styled.button`
	border: 0;
	background: none;
	padding: 0;
	margin-top: 0.3rem;
	color: ${Theme.blue};
	font-size: 13px;
	font-weight: 600;
	cursor: pointer;
`;

export const OrderNotesDetailsContainer = styled(Common.Container)`
    margin: 0rem;
    border: 0.5px solid #EAEAEA;
    border-radius: 5px;
    background-color : #FFFFFF;
    line-height: 24px;
    font-size; 16px;
    font-weight: 500;
`;

export const OrderNotesDetailsHeader = styled(Common.FlexRow)`
	display: flex;
	flex-direction: column;
	padding: 1rem 2rem 0rem;
	font-weight: bold;
	font-size: 22px;
	line-height: 22px;
`;
export const OrderNotesDetailsSubHeader = styled(Common.FlexRow)`
	display: flex;
	flex-direction: column;
	padding: 1rem 2rem 0rem;
	font-weight: bold;
	font-size: 14px;
	line-height: 18px;
	color: #adadad;
`;

export const OrderNotesSummaryContainer = styled(Common.Container)`
	margin: 0.75rem 2rem;
	width: auto;
`;

export const PaymentDetailsContainer = styled(Common.Container)`
    margin: 0rem;
    border: 0.5px solid #EAEAEA;
    border-radius: 5px;
    background-color : #FFFFFF;
    line-height: 24px;
    font-size; 16px;
    font-weight: 500;
`;

export const PaymentDetailsHeader = styled(Common.FlexRow)`
	display: flex;
	flex-direction: column;
	padding: 1rem 2rem 0rem;
	font-weight: bold;
	font-size: 22px;
	line-height: 22px;
`;

export const PaymentSummaryContainer = styled(Common.Container)`
	margin: 0.75rem 2rem;
	width: auto;
`;

export const PaymentLine = styled(Common.FlexRow)`
	margin: 0.5rem 0 0 0;
	border: 0px solid #eaeaea;
	border-bottom-width: 1px;
`;

export const PaymentConclusion = styled(Common.FlexRow)`
	margin: 0.5rem 0 0 0;
	color: #ff7004;
	border: 0px solid #eaeaea;
	border-bottom-width: 1px;
`;

export const PaymentKey = styled(Common.FlexColumn)``;

export const PaymentValue = styled(Common.FlexColumn)`
	margin: 0 0 0 auto;
	padding: 4px;
	font-weight: bold;
`;

export const CustomerDetailsContainer = styled(Common.Container)`
	height: calc(100vh - 185px);
	margin: 0rem;
	background-color: #ffffff;
	border: 0.5px solid #eaeaea;
	border-radius: 5px;
`;

export const CustomerDetailsHeader = styled(FlexRow)`
	display: flex;
	flex-direction: column;
	padding: 1.75rem 2rem 0rem;
	font-weight: bold;
	font-size: 22px;
	line-height: 22px;
`;

export const CustomerSummaryContainer = styled(Common.Container)`
	margin: 1rem 2rem 1rem 2rem;
	diplay: flex;
	flex: 1;
	width: auto;
	overflow: scroll;
`;

export const CustomerImage = styled.div`
	display: flex;
	width: 3.5rem;
	height: 3.5rem;
	margin: 1rem 0;
	background-color: #00ad6f33;
	border: 0.5px solid #eaeaea;
	border-radius: 50%;
	align-self: flex-start;
	& svg {
		align-self: center;
		margin: 0 auto;
		font-size: 30px;
	}
`;

export const CustomerDetailsLine = styled(Common.FlexColumn)`
    width: auto;
    padding: 1rem 0;
    line-height: 28px;
    font-size; 14px;
    border: 0px solid #EAEAEA;
    border-bottom-width: 1px;
`;

export const CustomerDetailsKey = styled(Common.FlexRow)`
	font-weight: bold;
`;

export const CustomerDetailsValue = styled(Common.FlexRow)`
	word-break: break-all;
`;

export const OrderTrackingLink = styled.a`
	font-size: 14px;
	align-items: center;
	color: ${Theme.blue};
	
	& svg {
		font-size: 18px;
		vertical-align: sub;
	}
`;

export const ShipmentLine = styled(Common.FlexRow)`
	justify-content: space-between;
	align-items: flex-start;
	gap: 1rem;
	padding: 0.4rem 0;
`;

export const ShipmentDivider = styled.div`
	margin-top: 0.25rem;
	border-top: 0.5px solid #eaeaea;
`;

export const ShipmentKey = styled.span`
	color: #666666;
	font-size: 13px;
	flex-shrink: 0;
`;

export const ShipmentValue = styled.span`
	font-weight: bold;
	font-size: 13px;
	min-width: 0;
	overflow-wrap: anywhere;
	text-align: right;
`;

export const ShipmentValueLight = styled.span`
	font-weight: normal;
	color: #666666;
	font-size: 13px;
`;

export const ShipmentTrackingLink = styled.a`
	color: ${Theme.primary};
	font-weight: bold;
	text-decoration: underline;
	font-size: 13px;
`;

export const ShipmentNote = styled.div`
	margin-top: 0.5rem;
	font-size: 12px;
	color: #999999;
`;

export const MoreDetails = styled(Common.FlexRow)`
	padding: 1rem 2rem;
	background-color: #fdfcfa;
	border: 1px solid #eaeaea;
	font-size: 16px;
	line-height: 20px;
`;
